import http from "./httpService";

export default async function getCustomerDetailsByIp(ipAddress: string){
    try {
        const res = await http.get(`/api/CustomerDetailsbyIP/CustomerDetailsbyIP?ipaddress=${ipAddress}`);
        return res.data?.data[0][0];
    } catch(err) {
        console.log(err);
    }
}